module.exports = __webpack_public_path__ + "img/04353469005043.2db7f698.png";